import styled from "styled-components";

export const FleetPickerPaddingStyled = styled.div`
  padding: 32px 32px 21px;
`;
